import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Download } from 'lucide-react';
import Button from '../../components/ui/Button';
import { getErrorMessage } from '../../lib/apiClient';
import { downloadWaiverCopy } from './signaturesApi';
import PublicShell from './components/PublicShell';

/** Landing page for the emailed waiver-copy link (/w/copy/:downloadToken). */
export default function WaiverCopyPage() {
  const { downloadToken } = useParams();
  return (
    <PublicShell title="Your signed document">
      <div className="mx-auto max-w-lg space-y-4 rounded-2xl border border-slate-200 bg-slate-100 p-8 text-center">
        <Download className="mx-auto h-12 w-12 text-brand-600" />
        <h2 className="text-lg font-semibold text-slate-900">Download your signed copy</h2>
        <p className="text-sm text-slate-500">
          This personal link retrieves the document you signed, including its signature certificate.
        </p>
        <Button
          onClick={() =>
            downloadWaiverCopy(downloadToken).catch((err) => toast.error(getErrorMessage(err)))
          }
        >
          <Download className="h-4 w-4" /> Download PDF
        </Button>
      </div>
    </PublicShell>
  );
}
